import { useEffect } from 'react';
import React from 'react';
import { useState } from 'react';

import { DownOutlined } from '@ant-design/icons';
import { Collapse, Form, message, Spin, Input, Button, Space, DatePicker, InputNumber, Card } from 'antd';
import dayjs from 'dayjs';

import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import '../Antd.css';
import CmbClienti from '../Combos/CmbClienti';
import CmbGenerico from '../Combos/CmbGenerico';

export default function OpportunitaAddEdit(props) {
    const [idOpportunita, SetidOpportunita] = useState(props?.idOpportunita);

    const [isOpportunitaLoading, setIsOpportunitaLoading] = useState(false);
    const [apriCliente, setApriCliente] = useState('0');
    const [ragioneSociale, setRagioneSociale] = useState(undefined);

    const [form] = Form.useForm();

    const [iconaCollapse, setIconaCollapse] = useState(<DownOutlined />);
    function onClickButtonPlus() {
        if (apriCliente === '1') setApriCliente('0');
        else setApriCliente('1');
    }

    function onSelected(val) {
        if (val != null) {
            form.setFieldValue('codCliente', val.codCliente);
            form.setFieldValue('ragioneSociale', val.ragioneSociale);
            setRagioneSociale(val.ragioneSociale);
            form.setFieldValue('nome', val.nome);
            form.setFieldValue('cognome', val.cognome);
            form.setFieldValue('posizione', val.posizione);
            form.setFieldValue('email', val.email);
            form.setFieldValue('telefono', val.telefono);
            form.setFieldValue('partitaIva', val.partitaIva);
            form.setFieldValue('codFiscale', val.codFiscale);
            form.setFieldValue('indirizzo', val.indirizzo);
            form.setFieldValue('localita', val.localita);
            form.setFieldValue('Provincia', val.Provincia);
            form.setFieldValue('cAP', val.cAP);
            form.setFieldValue('codNazione', val.codNazione);
        } else {
            form.resetFields();
        }
    }

    useEffect(() => {
        async function onLoad() {
            try {
                if (props?.idOpportunita == null) return;

                setIsOpportunitaLoading(true);
                const data = {
                    idSocieta: sessionManager.get(eVariableType.IDSocieta),
                    idOpportunita: props?.idOpportunita,
                };
                const result = await api.post('CRM/Opportunita', data);

                if (result != null && result.data != null) {
                    const dati = result.data[0];

                    onSelected(dati);
                    form.setFieldValue('oggetto', dati.oggetto);
                    form.setFieldValue('descrizione', dati.descrizione);
                    form.setFieldValue('idStatoOpportunita', dati.idStatoOpportunita);
                    form.setFieldValue('idTipologiaOpportunita', dati.idTipologiaOpportunita);
                    form.setFieldValue('importoPrevisto', dati.importoPrevisto);
                    form.setFieldValue('dataPrevistaChiusura', dayjs(dati.dataPrevistaChiusura));
                }
            } catch (error) {
                message.error(error.message.response.data.message);
            } finally {
                setIsOpportunitaLoading(false);
            }
        }

        onLoad();
    }, [props]);

    async function OnFinishok() {
        try {
            setIsOpportunitaLoading(true);
            const data = {
                idOpportunita: idOpportunita,
                idSocieta: sessionManager.get(eVariableType.IDSocieta),
                codCliente: form.getFieldValue('codCliente'),
                ragioneSociale: form.getFieldValue('ragioneSociale'),
                nome: form.getFieldValue('nome'),
                cognome: form.getFieldValue('cognome'),
                partitaIva: form.getFieldValue('partitaIva'),
                telefono: form.getFieldValue('telefono'),
                cellulare: form.getFieldValue('cellulare'),
                email: form.getFieldValue('email'),
                indirizzo: form.getFieldValue('indirizzo'),
                localita: form.getFieldValue('localita'),
                provincia: form.getFieldValue('provincia'),
                cAP: form.getFieldValue('cap'),
                codNazione: form.getFieldValue('codNazione'),
                posizione: form.getFieldValue('posizione'),
                oggetto: form.getFieldValue('oggetto'),
                descrizione: form.getFieldValue('descrizione'),
                idStatoOpportunita: form.getFieldValue('idStatoOpportunita'),
                idTipologiaOpportunita: form.getFieldValue('idTipologiaOpportunita'),
                importoPrevisto: form.getFieldValue('importoPrevisto'),
                dataPrevistaChiusura: form.getFieldValue('dataPrevistaChiusura'),
                idOperatore: sessionManager.get(eVariableType.IDOperatore),
            };

            const resul = await api.post('CRM/Opportunita/InsertUpdateOpportunitaConProspect', data);
            if (resul != null && resul.data != null) {
                SetidOpportunita(resul.data.idOpportunita);
                props.propagate(resul.data.idOpportunita);
                message.success(stringres.t('successo'));
            }
        } catch (error) {
            message.error(error.response.data.message, 5);
        } finally {
            setIsOpportunitaLoading(false);
        }
    }

    const itemsPanel = [
        {
            label: (
                <div>
                    <Form.Item name="ragioneSociale" label={stringres.t('ragioneSociale')} rules={[{ required: true }]}>
                        <div style={{ margin: '0px', display: 'flex', alignItems: 'center' }}>
                            <CmbClienti
                                readOnly={isNaN(props?.idOpportunita) ? false : true}
                                value={ragioneSociale}
                                name="ragioneSociale"
                                onSelected={onSelected}
                            ></CmbClienti>
                            <Button
                                style={{ marginLeft: '10px' }}
                                icon={iconaCollapse}
                                type="primary"
                                onClick={onClickButtonPlus}
                            ></Button>
                        </div>
                    </Form.Item>
                </div>
            ),
            key: 1,
            style: { margin: '0px', padding: '0px' },
            children: (
                <div>
                    <Form.Item>
                        <Form.Item className="Form-item-inline2componenti" name="nome" label={stringres.t('nome')}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            style={{ paddingLeft: '10px' }}
                            className="Form-item-inline2componenti"
                            name="cognome"
                            label={stringres.t('cognome')}
                        >
                            <Input />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item name="posizione" label={stringres.t('posizione')}>
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Form.Item
                            rules={[{ type: 'email', message: stringres.t('emailnonvalida') }]}
                            className="Form-item-inline2componenti"
                            name="email"
                            label={stringres.t('email')}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            style={{ paddingLeft: '10px' }}
                            className="Form-item-inline2componenti"
                            name="telefono"
                            label={stringres.t('telefono')}
                        >
                            <Input />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item>
                        <Form.Item
                            className="Form-item-inline2componenti"
                            name="partitaIva"
                            label={stringres.t('piva')}
                        >
                            <Input maxLength={16} />
                        </Form.Item>
                        <Form.Item
                            style={{ paddingLeft: '10px' }}
                            className="Form-item-inline2componenti"
                            name="codFiscale"
                            label={stringres.t('codicefiscale')}
                        >
                            <Input maxLength={20} />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item>
                        <Form.Item className="Form-item-inline" name="indirizzo" label={stringres.t('indirizzo')}>
                            <Input />
                        </Form.Item>
                        <Form.Item className="Form-item-inline" name="localita" label={stringres.t('Localita')}>
                            <Input />
                        </Form.Item>
                        <Form.Item className="Form-item-inline" name="provincia" label={stringres.t('Provincia')}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            className="Form-item-inline"
                            style={{ margin: '0px', width: '100px' }}
                            name="cAP"
                            label={stringres.t('CAP')}
                        >
                            <Input maxLength={5} />
                        </Form.Item>
                        <Form.Item
                            className="Form-item-inline"
                            style={{ width: '75px' }}
                            name="codNazione"
                            label={stringres.t('Nazione')}
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={2} />
                        </Form.Item>
                    </Form.Item>
                </div>
            ),
        },
    ];

    return (
        <Spin spinning={isOpportunitaLoading} size="large">
            <Form form={form} size="middle" onFinish={OnFinishok} layout="vertical" className="custom-form-reduced">
                <Collapse
                    items={itemsPanel}
                    style={{ backgroundColor: 'white' }}
                    bordered="false"
                    collapsible="icon"
                    vi
                    expandIcon={() => null}
                    size="large"
                    activeKey={apriCliente}
                ></Collapse>
                <Card title="Dati opportunità" style={{ marginTop: '10px' }}>
                    <Form.Item name="oggetto" label={stringres.t('oggetto')} rules={[{ required: true }]}>
                        <Input maxLength={255} />
                    </Form.Item>
                    <Form.Item name="descrizione" label={stringres.t('descrizione')}>
                        <Input.TextArea maxLength={255} />
                    </Form.Item>
                    <Form.Item>
                        <Form.Item
                            className="Form-item-inline2componenti"
                            name="idTipologiaOpportunita"
                            label={stringres.t('tipoopportunita')}
                            rules={[{ required: true }]}
                        >
                            <CmbGenerico
                                value={!form ? form.getFieldValue('idTipologiaOpportunita') : null}
                                placeholder={stringres.t('attivitatipo')}
                                onChange={(value) => form.setFieldsValue({ idTipologiaOpportunita: value })}
                                queryurl="CRM/Opportunita/Tipologie"
                                insertupdateurl="CRM/Opportunita/Tipologie/Insert"
                                deleteurl="CRM/Opportunita/Tipologie/Delete"
                                campoid="idTipologia"
                                campoidSocieta="idSocieta"
                                campoDescrizione="dettaglio"
                            ></CmbGenerico>
                        </Form.Item>
                        <Form.Item
                            style={{ paddingLeft: '10px' }}
                            className="Form-item-inline2componenti"
                            name="idStatoOpportunita"
                            label={stringres.t('statoopportunita')}
                            rules={[{ required: true }]}
                        >
                            <CmbGenerico
                                value={!form ? form.getFieldValue('idStatoOpportunita') : null}
                                placeholder={stringres.t('statoopportunita')}
                                onChange={(value) => form.setFieldsValue({ idStatoOpportunita: value })}
                                queryurl="CRM/Opportunita/Stati"
                                insertupdateurl="CRM/Opportunita/Stati/Insert"
                                deleteurl="CRM/Opportunita/Stati/Delete"
                                campoid="idStatoOpportunita"
                                campoidSocieta="idSocieta"
                                campoDescrizione="statoOpportunita"
                            ></CmbGenerico>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item>
                        <Form.Item
                            className="Form-item-inline"
                            name="importoPrevisto"
                            label={stringres.t('importo')}
                            rules={[{ required: true, pattern: new RegExp(/^[0-9]+$/) }]}
                        >
                            <InputNumber />
                        </Form.Item>
                        <Form.Item
                            className="Form-item-inline"
                            name="dataPrevistaChiusura"
                            label={stringres.t('dataprevistachiusura')}
                        >
                            <DatePicker
                                placeholder={stringres.t('dataprevistachiusura')}
                                showTime
                                format="YYYY-MM-DD HH:mm"
                            />
                        </Form.Item>
                    </Form.Item>
                </Card>
                <Form.Item style={{ textAlign: 'end', marginTop: '30px', marginRight: '25px' }}>
                    <Space>
                        <Button style={{ width: '120px' }} type="primary" htmlType="submit">
                            {stringres.t('conferma')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Spin>
    );
}
